const odinFirebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_APIKEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTHDOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
}
const pushFirebaseConfig = {
  apiKey: import.meta.env.VITE_PUSH_API_KEY,
  authDomain: import.meta.env.VITE_PUSH_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_PUSH_DATABASE_URL,
  projectId: import.meta.env.VITE_PUSH_PROJECT_ID,
  storageBucket: import.meta.env.VITE_PUSH_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_PUSH_SENDER_ID,
  appId: import.meta.env.VITE_PUSH_APP_ID
}

export { pushFirebaseConfig, odinFirebaseConfig }
